import BaseBehavior from '../../../framework/base/base';
import { showElement, hideElement } from '../../../shared/utilities/show-hide';
import { showOptions, toggleArrow } from '../../../shared/utilities/dropdownUtils';

export default class MultiselectDropdown extends BaseBehavior {
	constructor(element) {
		super(element);
		this.initDomCache();
		this.addEventListeners();
		// default check first option
		this.dom.items.firstElementChild.firstElementChild.checked = true;
		this.setAnchorDataValueInitially();
		this.subscribe('reset-to-default', ({ dpElement }) => {
			if (dpElement.contains(element)) {
				this.resetCheckBoxes();
				this.publish('reset-done', { dpElement, filterId: element.dataset.dropdownId });
			}
		});
	}

	setAnchorDataValueInitially() {
		const firstItemDataValues = this.dom.items.firstElementChild.firstElementChild.value;
		const anchorElem = this.dom.anchorElem.querySelector('.anchor-text--optional');
		anchorElem.dataset.value = firstItemDataValues;
		this.counter = 1;
		this.updateAnchorText();
	}

	updateAnchorText() {
		const counter = this.dom.anchorElem.querySelector('.anchor-text--optional .counter');
		const itemSelectedText = this.dom.anchorElem.querySelector('.anchor-text--optional .text');
		// Showing item name in case of one item is checked, else showing count
		if (this.counter === 1) {
			Array.from(this.dom.items.children).forEach(li => {
				if (li.firstElementChild.checked) {
					hideElement(itemSelectedText);
					counter.innerText = li.querySelector('label').innerText;
				}
			});
		} else {
			counter.innerText = this.counter;
			showElement(itemSelectedText);
		}
	}

	addEventListeners() {
		this.addEventListener(document, 'click', e => {
			if (e.target.closest('.dropdown-check-list')) {
				e.preventDefault();
				return;
			}
			this.hideOptions();
		});
		this.addEventListener(this.dom.anchorElem, 'click', evt => {
			evt.preventDefault();
			if (this.dom.expanded.classList.contains('v2-hidden')) {
				showOptions(this.dom.anchorElem, this.dom.expanded);
			} else {
				this.hideOptions();
			}
		});
		this.addEventListener(this.dom.items, 'click', this.selectCheckbox.bind(this));
		this.addEventListener(this.dom.submit, 'click', this.processData.bind(this));
		this.addEventListener(this.dom.reset, 'click', this.resetCheckBoxes.bind(this));
	}

	resetCheckBoxes() {
		Array.from(this.dom.items.children).forEach((li, index) => {
			li.firstElementChild.checked = index === 0;
		});
		this.setAnchorDataValueInitially();
	}

	updateDataset(anchor, existingValue, current, type) {
		if (type === 'remove') {
			const updatedValue = existingValue
				.replace(current, '')
				.replace(/,,/, ',')
				.replace(/^,/, '')
				.replace(/,$/, '');
			anchor.dataset.value = updatedValue;
		} else if (type === 'add') {
			anchor.dataset.value = (existingValue + `,${current}`).replace(/^,/, '');
		}
	}

	// eslint-disable-next-line
	selectCheckbox(e) {
		const { nodeName } = e.target;
		if (nodeName === 'UL') return false;
		const checkBox = e.target.closest('li').querySelector('input');
		const anchorElement = this.dom.anchorElem.querySelector('.anchor-text--optional');
		// is already selected
		if (checkBox.checked) {
			if (this.counter !== 1) {
				checkBox.checked = false;
				--this.counter;
				this.updateDataset(anchorElement, anchorElement.dataset.value, checkBox.value, 'remove');
				this.updateAnchorText();
			}
			return false;
		}
		checkBox.checked = true;
		this.updateDataset(anchorElement, anchorElement.dataset.value, checkBox.value, 'add');
		const allElement = this.dom.items.firstElementChild;
		if (!(e.target.closest('li') === allElement) && allElement.firstElementChild.checked) {
			allElement.firstElementChild.checked = false;
			anchorElement.dataset.value = '';
			this.updateDataset(anchorElement, '', checkBox.value, 'add');
			--this.counter;
		} else if (e.target.closest('li') === allElement) {
			this.counter = 0;
			Array.from(this.dom.items.children).forEach(li => {
				li.firstElementChild.checked = false;
			});
			allElement.firstElementChild.checked = true;
			anchorElement.dataset.value = allElement.firstElementChild.value;
		}
		++this.counter;
		this.updateAnchorText();
		return true;
	}

	hideOptions() {
		hideElement(this.dom.expanded);
		toggleArrow(this.dom.anchorElem, 'v2-arrow-indicator--up', 'v2-arrow-indicator--down');
	}

	processData() {
		const selectedElements = [];
		if (this.element.dataset.publishChange === 'true') {
			Array.from(this.dom.items.children).forEach((li, index) => {
				if (li.firstElementChild.checked) {
					const { value } = li.children[0];
					const element = index === 0 ? value.split(',') : value;
					selectedElements.push(element);
				}
			});
			const dpFilter = this.element.closest('.dynamic-pricing__filters');
			const targetID = dpFilter ? dpFilter.dataset.guid : '';
			this.publish(`/cb-dropdown/change`, {
				dropdownId: this.element.dataset.dropdownId,
				value: selectedElements,
				targetID
			});
			this.hideOptions();
		}
	}

	removeEventListeners() {
		this.removeEventListener(this.dom.items, 'click');
		this.removeEventListener(this.dom.anchorElem, 'click');
		this.removeEventListener(this.dom.submit, 'click');
		this.removeEventListener(this.dom.reset, 'click');
	}

	cleanup() {
		this.removeEventListeners();
	}
}
